import { render, staticRenderFns } from "./countDown.vue?vue&type=template&id=524d2e13&scoped=true&"
import script from "./countDown.vue?vue&type=script&lang=js&"
export * from "./countDown.vue?vue&type=script&lang=js&"
import style0 from "./countDown.vue?vue&type=style&index=0&id=524d2e13&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524d2e13",
  null
  
)

export default component.exports